module.exports = __webpack_public_path__ + "img/google_play.83a9deae.png";